import { render, staticRenderFns } from "./NearestPharmacy.vue?vue&type=template&id=885eb884"
import script from "./NearestPharmacy.vue?vue&type=script&lang=js"
export * from "./NearestPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports